import { render, staticRenderFns } from "./SomosDiferentes.vue?vue&type=template&id=469253ba&"
import script from "./SomosDiferentes.vue?vue&type=script&lang=js&"
export * from "./SomosDiferentes.vue?vue&type=script&lang=js&"
import style0 from "./SomosDiferentes.vue?vue&type=style&index=0&id=469253ba&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports